export const parsingNotifications = {
    success: "activation.topics.modal.notification.import.success",
    outOfLimit: "activation.topics.modal.notification.import.failed.out_of_limit",
    failed: "activation.topics.modal.notification.import.failed",
};

export const COMMON_API_ERROR_MESSAGE = "common.api.error";
//TODO improve
export const commonButtonText = {
    close: "global.cancel",
};
